import {
  billingOverviewSchema,
  checkoutResponseSchema,
  seatPreviewSchema,
  type BillingOverview,
  type CheckoutRequest,
  type CheckoutResponse,
  type SeatPreview,
} from "@contract/firm/billing";
import { z } from "zod";
import { apiRequest } from "./client";

/** Plan & billing (firm-model spec §7): every call needs `manage_billing`. */
export function fetchBilling(): Promise<BillingOverview> {
  return apiRequest("/v1/billing", {}, (json) => billingOverviewSchema.parse(json));
}

export function startCheckout(req: CheckoutRequest): Promise<CheckoutResponse> {
  return apiRequest("/v1/billing/checkout", { method: "POST", body: req }, (json) => checkoutResponseSchema.parse(json));
}

export function previewSeats(seats: number): Promise<SeatPreview> {
  return apiRequest("/v1/billing/seats/preview", { method: "POST", body: { seats } }, (json) => seatPreviewSchema.parse(json));
}

export async function changeSeats(seats: number): Promise<void> {
  await apiRequest("/v1/billing/seats", { method: "POST", body: { seats } });
}

/** What the Individual → Team upgrade charges now and then each period (a live
 * subscription only; a new one prices itself in Paddle's checkout). */
export function previewUpgrade(req: CheckoutRequest): Promise<SeatPreview> {
  return apiRequest("/v1/billing/checkout/preview", { method: "POST", body: req }, (json) => seatPreviewSchema.parse(json));
}

/** A fresh Paddle customer-portal session (invoices, payment method, and cancelling: the
 * panel has no cancel of its own since 2026-10-04). */
export async function portalUrl(): Promise<string> {
  const res = await apiRequest("/v1/billing/portal", { method: "POST" }, (json) => z.object({ url: z.string() }).parse(json));
  return res.url;
}
